import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] px-5 py-14 text-center" data-id="element-68">
      <div className="mx-auto max-w-4xl" data-id="element-69">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-[#d4af37]" data-id="element-70">
          RUGBY PRÊT™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-71">
          Le système le plus complet pour entraîneurs ambitieux.
        </p>
        <p className="mt-2 text-sm italic text-[#B0B0C0]" data-id="element-72">
          Parce que le coaching ne devrait pas vous coûter toutes vos soirées.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-[#d4af37]/20 py-6 text-sm font-semibold text-[#B0B0C0]" data-id="element-73">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support@rugbypret.com" data-id="element-74">
            <MailIcon className="h-4 w-4 text-[#d4af37]" data-id="element-75" />
            support@rugbypret.com
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/rugbypret" data-id="element-76">
            <InstagramIcon className="h-4 w-4 text-[#d4af37]" data-id="element-77" />
            @rugbypret
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://rugbypret.com" data-id="element-78">
            <Globe2Icon className="h-4 w-4 text-[#d4af37]" data-id="element-79" />
            rugbypret.com
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-80">
          © Rugby Prêt™ 2026 — Tous droits réservés
        </p>
      </div>
    </footer>;
}